import { render, staticRenderFns } from "./Utm.vue?vue&type=template&id=26b5fafe&scoped=true"
import script from "./Utm.vue?vue&type=script&lang=js"
export * from "./Utm.vue?vue&type=script&lang=js"
import style0 from "./Utm.vue?vue&type=style&index=0&id=26b5fafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b5fafe",
  null
  
)

export default component.exports